import { createSlice } from "@reduxjs/toolkit";

export const ratingSlice = createSlice({
  name: "rating",
  initialState: {
    getRatingResult: false,
    getRatingLoading: false,
    getRatingError: false,
    addRatingResult: false,
    addRatingLoading: false,
    deleteRatingResult: false,
  },
  reducers: {
    ratingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_RATING":
          return {
            ...state,
            getRatingResult: payload.data,
            getRatingLoading: payload.loading,
            getRatingError: payload.error,
          };
        case "ADD_RATING":
          return {
            ...state,
            addRatingResult: payload.data,
            addRatingLoading: payload.loading,
          };
        case "DELETE_RATING":
          return {
            ...state,
            deleteRatingResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { ratingReducers } = ratingSlice.actions;

export default ratingSlice.reducer;
